exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bell-size {\n    margin-top: 4px;\n    font-size: 1.16rem;\n}\n.notification-badge {\n    position: absolute;\n    margin-left: -7px;\n}\n.notification {\n    padding: 10px;\n}\n.notification:hover {\n    background: #F8F8F8;\n}\n", ""]);

// exports
